import { useCallback, useMemo } from "react";
import { useTranslation } from "../hooks";
/* eslint-disable @typescript-eslint/naming-convention -- Object keys are external moderation reason codes (e.g. "AR-CB002", "USR-06") returned verbatim by the backend. */
/* eslint-disable id-length -- "t" follows the i18next convention and is required for static translation key extraction. */
const buildModerationReasonTranslators = (t) => ({
    "AR-CB002": (defaultValue) => t("chatbot:moderation.reason.ar-cb002", { defaultValue }),
    "CC-NO003": (defaultValue) => t("chatbot:moderation.reason.cc-no003", { defaultValue }),
    "CM-YP031": (defaultValue) => t("chatbot:moderation.reason.cm-yp031", { defaultValue }),
    "OC-UO027": (defaultValue) => t("chatbot:moderation.reason.oc-uo027", { defaultValue }),
    "PT-FR034": (defaultValue) => t("chatbot:moderation.reason.pt-fr034", { defaultValue }),
    "PT-IN013": (defaultValue) => t("chatbot:moderation.reason.pt-in013", { defaultValue }),
    "PT-NC012": (defaultValue) => t("chatbot:moderation.reason.pt-nc012", { defaultValue }),
    "RR-IP017": (defaultValue) => t("chatbot:moderation.reason.rr-ip017", { defaultValue }),
    "RR-UI015": (defaultValue) => t("chatbot:moderation.reason.rr-ui015", { defaultValue }),
    "RR-UP016": (defaultValue) => t("chatbot:moderation.reason.rr-up016", { defaultValue }),
    "SC-CG022": (defaultValue) => t("chatbot:moderation.reason.sc-cg022", { defaultValue }),
    "SC-DX032": (defaultValue) => t("chatbot:moderation.reason.sc-dx032", { defaultValue }),
    "SC-EG019": (defaultValue) => t("chatbot:moderation.reason.sc-eg019", { defaultValue }),
    "SC-EV018": (defaultValue) => t("chatbot:moderation.reason.sc-ev018", { defaultValue }),
    "SC-GM033": (defaultValue) => t("chatbot:moderation.reason.sc-gm033", { defaultValue }),
    "SC-IA020": (defaultValue) => t("chatbot:moderation.reason.sc-ia020", { defaultValue }),
    "SC-NH024": (defaultValue) => t("chatbot:moderation.reason.sc-nh024", { defaultValue }),
    "SC-PC025": (defaultValue) => t("chatbot:moderation.reason.sc-pc025", { defaultValue }),
    "SC-SB029": (defaultValue) => t("chatbot:moderation.reason.sc-sb029", { defaultValue }),
    "SC-SH023": (defaultValue) => t("chatbot:moderation.reason.sc-sh023", { defaultValue }),
    "SC-TM026": (defaultValue) => t("chatbot:moderation.reason.sc-tm026", { defaultValue }),
    "SC-YD021": (defaultValue) => t("chatbot:moderation.reason.sc-yd021", { defaultValue }),
    "UC-DD006": (defaultValue) => t("chatbot:moderation.reason.uc-dd006", { defaultValue }),
    "UC-EC009": (defaultValue) => t("chatbot:moderation.reason.uc-ec009", { defaultValue }),
    "UC-GL010": (defaultValue) => t("chatbot:moderation.reason.uc-gl010", { defaultValue }),
    "UC-IR008": (defaultValue) => t("chatbot:moderation.reason.uc-ir008", { defaultValue }),
    "UC-OI005": (defaultValue) => t("chatbot:moderation.reason.uc-oi005", { defaultValue }),
    "UC-RH007": (defaultValue) => t("chatbot:moderation.reason.uc-rh007", { defaultValue }),
    "USR-06": (defaultValue) => t("chatbot:moderation.reason.usr-06", { defaultValue }),
});
export default function useTranslatedModerationReason() {
    const { t } = useTranslation();
    const translatedModerationReasons = useMemo(() => buildModerationReasonTranslators(t), [t]);
    const getTranslatedModerationReason = useCallback((code, fallback) => {
        const defaultValue = fallback ?? "";
        if (!code) {
            return defaultValue;
        }
        const translateForCode = translatedModerationReasons[code];
        return translateForCode ? translateForCode(defaultValue) : defaultValue;
    }, [translatedModerationReasons]);
    return { getTranslatedModerationReason };
}
